<div class="article-manager">
  <div class="table-operations">
    <div nz-row [nzGutter]="16" nzAlign="middle">
      <div nz-col [nzSpan]="6">
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" nz-input [(ngModel)]="searchKeyword" placeholder="搜索标题或摘要" (keyup.enter)="loadArticles()" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" nzSearch (click)="loadArticles()"><span nz-icon nzType="search"></span></button>
        </ng-template>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-select [(ngModel)]="selectedSyllabusId" nzPlaceHolder="按分类筛选" (ngModelChange)="loadArticles()" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let item of syllabusList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzSpan]="12" style="text-align: right;">
        <button nz-button nzType="primary" (click)="openAdd()">发布文章</button>
      </div>
    </div>
  </div>

  <nz-table
    #basicTable
    [nzData]="articles"
    [nzLoading]="loading"
    nzTableLayout="fixed"
    [nzFrontPagination]="false"
    [nzTotal]="total"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    (nzPageIndexChange)="onPageIndexChange($event)"
  >
    <thead>
      <tr>
        <th nzWidth="60px">ID</th>
        <th>标题</th>
        <th nzWidth="150px">分类</th>
        <th nzWidth="100px">浏览量</th>
        <th nzWidth="100px">状态</th>
        <th nzWidth="180px">创建时间</th>
        <th nzWidth="150px">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.id }}</td>
        <td nzEllipsis [nzTooltipTitle]="data.title" nz-tooltip>{{ data.title }}</td>
        <td>{{ data.syllabusName || '-' }}</td>
        <td>{{ data.views }}</td>
        <td>
          <nz-tag [nzColor]="getStatusColor(data.status)">{{ getStatusText(data.status) }}</nz-tag>
        </td>
        <td>{{ data.createdAt | date:'yyyy-MM-dd HH:mm' }}</td>
        <td>
          <a (click)="openEdit(data.id)">编辑</a>
          <nz-divider nzType="vertical"></nz-divider>
          <a class="delete-btn" (click)="deleteArticle(data.id)">删除</a>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- Article Edit Drawer -->
  <nz-drawer
    [nzBodyStyle]="{ overflow: 'auto', paddingBottom: '53px' }"
    [nzMaskClosable]="false"
    [nzWidth]="800"
    [nzVisible]="drawerVisible"
    [nzTitle]="drawerTitle"
    [nzFooter]="footerTpl"
    (nzOnClose)="closeDrawer()"
  >
    <ng-container *nzDrawerContent>
      <form nz-form class="drawer-form" [formGroup]="articleForm" layout="vertical">
        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="24">
            <nz-form-item>
              <nz-form-label nzRequired>文章标题</nz-form-label>
              <nz-form-control nzErrorTip="请输入标题">
                <input nz-input formControlName="title" placeholder="请输入文章标题" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="24">
            <nz-form-item>
              <nz-form-label>所属分类</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="syllabusId" nzPlaceHolder="请选择分类" nzAllowClear>
                  <nz-option *ngFor="let item of syllabusList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <nz-form-item>
          <nz-form-label>摘要</nz-form-label>
          <nz-form-control>
            <textarea nz-input formControlName="summary" placeholder="简短的文章摘要" [nzAutosize]="{ minRows: 2, maxRows: 4 }"></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>内容</nz-form-label>
          <nz-form-control nzErrorTip="请输入内容">
            <nz-spin class="image-uploading-container" [nzDelay]="500" [nzSpinning]="isImageUploading" [nzIndicator]="uploadIndicatorTemplate">
            <div class="editor-wrapper">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"></ngx-editor-menu>
              <ngx-editor class="my-editor" [editor]="editor" formControlName="content" [placeholder]="'开始创作...'"></ngx-editor>
            </div>
            </nz-spin>
          </nz-form-control>
        </nz-form-item>

        <ng-template #customMenu>
          <div class="NgxEditor__Seperator"></div>
          <div
            class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
            (click)="imageInput.click()"
          >
            上传图片
          </div>
          <input
            #imageInput
            type="file"
            accept="image/*"
            style="display: none;"
            (change)="onImageSelected($event)"
          />
        </ng-template>
        <ng-template #uploadIndicatorTemplate>
          <nz-progress class="image-uploading-item" [nzPercent]="imageUploadProgress" nzType="circle"></nz-progress>
        </ng-template>

        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>标签</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="tagIds" nzMode="multiple" nzPlaceHolder="选择已有标签">
                  <nz-option *ngFor="let tag of availableTags" [nzValue]="tag.id" [nzLabel]="tag.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>新增标签</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="newTagNames" nzMode="tags" nzPlaceHolder="输入新标签，回车添加">
                  <nz-option *ngFor="let name of articleForm.get('newTagNames')?.value" [nzValue]="name" [nzLabel]="name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>文章封面</nz-form-label>
              <nz-form-control>
                <app-upload-image-with-preview-v2
                  [picUrl]="articleForm.get('cover')?.value"
                  (imageUploaded)="onCoverUploaded($event)"
                  [displayRatioWidth]="16"
                  [displayRatioHeight]="9"
                ></app-upload-image-with-preview-v2>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>状态</nz-form-label>
              <nz-form-control>
                <nz-radio-group formControlName="status">
                  <label nz-radio [nzValue]="1">发布</label>
                  <label nz-radio [nzValue]="0">草稿</label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-template #footerTpl>
      <div style="float: right">
        <button nz-button style="margin-right: 8px;" (click)="closeDrawer()">取消</button>
        <button nz-button nzType="primary" (click)="saveArticle()" [nzLoading]="loading">提交</button>
      </div>
    </ng-template>
  </nz-drawer>
</div>

